/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./GiftCards.scss";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { freezOn, freezOff, handleError } from "../../redux-store/action";
import { Countries, getMaxDigits, phonePatterns, validatePhoneNumber, getMaskPattern } from "../../utils/phoneValidation";
import InputMaskField from "../react-input-mask/inputfield";
import InputAdornment from "@mui/material/InputAdornment";
import IMAGES from "../../loginSignUp/Assets/images2";
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux-store/store";

export default function GiftCards(props) {
  const { show = false, handleClick, closebtn } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setDeliveryAddsInfo, setDeliveryGiftCards } = bindActionCreators(actionCreators, dispatch)

  const appState = useSelector((appState) => appState);
    

  const [formValue, setFormValue] = useState({
    gift_message: appState?.deliveryGiftCards?.gift_message || "",
    gift_link: appState?.deliveryGiftCards?.gift_link || "",
    gift_name: appState?.deliveryGiftCards?.gift_name || "",
    gift_call_recipient: appState?.deliveryGiftCards?.gift_call_recipient || false,
    gift_country_code: appState?.deliveryGiftCards?.gift_country_code || Countries[0].dial_code.replace("+", ""),
    gift_number: appState?.deliveryGiftCards?.gift_number || "",
  });

  const [giftCountry, setGiftCountry] = useState(Countries[0]);
  const [giftPhoneError, setGiftPhoneError] = useState("");

  const handleCheckboxChange = (e) => {
    setFormValue({
      ...formValue,
      gift_call_recipient: e.target.checked,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "gift_number") {
      const maxDigits = getMaxDigits(giftCountry?.code);
      if (value.length <= maxDigits) {
        setFormValue({ ...formValue, [name]: value });

        // ✅ Enhanced phone validation using validatePhoneNumber
        if (value.length > 0) {
          const validation = validatePhoneNumber(value, giftCountry.code);
          setGiftPhoneError(validation.error);
        } else {
          setGiftPhoneError("");
        }
      }
    } else if (name === "gift_country_code") {
      setFormValue({ ...formValue, [name]: value });
      const selected = Countries.find(
        (c) => c.dial_code.replace("+", "") === value
      );
      if (selected) setGiftCountry(selected);
    } else {
      setFormValue({ ...formValue, [name]: value });
    }
  };

  const validateGiftFields = () => {
    if (!formValue.gift_name) return t("Receiver name is required");
    if (!formValue.gift_message) return t("Gift message is required");
    if (!formValue.gift_country_code) return t("Receiver country code is required");
    if (!formValue.gift_number) return t("Receiver phone number is required");

    // ✅ Enhanced phone validation
    const validation = validatePhoneNumber(formValue.gift_number, giftCountry.code);
    if (!validation.isValid) {
      return validation.error;
    }
    return null;
  };

  const handleSubmit = () => {
    const error = validateGiftFields();
    if (error) {
      dispatch(handleError(error));
      return;
    }

    setDeliveryGiftCards({ ...appState?.deliveryGiftCards, ...formValue, is_gift: true })
    // handleClick && handleClick(null);
    
    dispatch(handleError(t("Gift added successfully.")));
    closebtn && closebtn();
  };

  const handleUpdate = () => {
    const error = validateGiftFields();
    if (error) {
      dispatch(handleError(error));
      return;
    }

    setDeliveryGiftCards({  ...formValue, is_gift: true })
    closebtn && closebtn();
    dispatch(handleError(t("Gift updated successfully.")));
  };

  useEffect(() => {
    if (appState?.deliveryGiftCards?.is_gift) {
      const selected = Countries.find(
        (c) =>
          c.dial_code.replace("+", "") ===
          appState?.deliveryGiftCards?.gift_country_code
      );
      if (selected) setGiftCountry(selected);

      setFormValue({
        gift_message: appState?.deliveryGiftCards?.gift_message || "",
        gift_link: appState?.deliveryGiftCards?.gift_link || "",
        gift_name: appState?.deliveryGiftCards?.gift_name || "",
        gift_call_recipient: appState?.deliveryGiftCards?.gift_call_recipient || false,
        gift_country_code:
          appState?.deliveryGiftCards?.gift_country_code || Countries[0].dial_code.replace("+", ""),
        gift_number: appState?.deliveryGiftCards?.gift_number || "",
      });
    }
  }, [appState?.deliveryGiftCards]);

  return (
    <>
      <div className={`giftCardsBackdrop ${show ? 'show' : ''}`} onClick={() => handleClick && handleClick(null)} />
      <div className={`giftCardsMain ${show ? 'show' : ''}`}>

      
      <div className="giftCardsHeader">
        <h3 className="giftCardsTitle">
          {appState?.deliveryGiftCards?.is_gift ? t("Edit Gift") : t("Add Gift")}
        </h3>
        <Button
          variant="outlined"
          onClick={() => closebtn && closebtn()}
          className="closeBtn"
        >
          ✕
        </Button>
      </div>

      <div className="giftCardsBody">
        <div className={`formGroup ${appState?.langValue === "ar" ? "classforArabicPhoneField" : ""}`}>
          <TextField
            fullWidth
            type="text"
            name="gift_name"
            label={t("Receiver Name")}
            required
            value={formValue.gift_name}
            onChange={handleChange}
            placeholder={t("Enter Receiver Name")}
            variant="outlined"
            margin="normal"
            className="giftInput"
          />
        </div>

        <div className="formGroup">
          {/* <div className="countrySelector">
            <label className="formLabel">{t("Select Country")}</label>
            <select
              name="gift_country_code"
              className="countrySelect"
              value={formValue.gift_country_code}
              onChange={handleChange}
            >
              {Countries.map((c) => (
                <option key={c.code} value={c.dial_code.replace("+", "")}>
                  {c.name} ({c.dial_code})
                </option>
              ))}
            </select>
          </div> */}
          <InputMaskField
            value={formValue.gift_number}
            onChange={handleChange}
            inputProps={{ inputMode: "numeric", autoComplete: "off" }}
            autoFocus={false}
            autoComplete="off"
            label={t("Receiver Phone")}
            className="mt-2"
            variant="outlined"
            type="tel"
            mask={getMaskPattern(giftCountry.code)}
            id="gift-phone-input"
            name="gift_number"
            error={!!giftPhoneError}
            helperText={giftPhoneError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img
                    className="inputadornmentImg flagImg"
                    src={IMAGES.kuwaitinput}
                    alt="flag"
                  />
                  <span className="px-2 textOver mobCode">
                    +{formValue.gift_country_code}
                    <span className="countryCode"></span>
                  </span>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={`formGroup ${appState?.langValue === "ar" ? "classforArabicTextField" : ""}`}>
          <TextField
            fullWidth
            type="text"
            name="gift_message"
            label={t("Gift Message")}
            required
            value={formValue.gift_message}
            onChange={handleChange}
            placeholder={t("Enter Gift Message")}
            variant="outlined"
            margin="normal"
            className="giftInput"
          />
        </div>

        <div className="checkboxGroup d-flex align-item-center ">
          <label htmlFor="giftCallRecipientCheck p-0 m-0" className="checkboxLabel d-flex align-item-center">
            <span className="phoneIcon"><AddIcCallIcon /></span>
            <span className="">  {t("Call recipient for gift delivery")} </span>
          </label>

          <input
            type="checkbox"
            id="giftCallRecipientCheck"
            className="checkboxInput"
            checked={!!formValue.gift_call_recipient}
            onChange={handleCheckboxChange}
            style={{borderRadius: '2.25rem', marginLeft: '10px'}}
          />
        </div>

        <div className={`formGroup ${appState?.langValue === "ar" ? "classforArabicTextField" : ""}`}>
          <TextField
            fullWidth
            type="text"
            name="gift_link"
            label={t("Share your Feelings with a video")}
            value={formValue.gift_link}
            onChange={handleChange}
            placeholder={t("Attach Video Link")}
            variant="outlined"
            margin="normal"
            className="giftInput"
          />
        </div>
      </div>

      <div className="giftCardsFooter">
        <Button
          variant="outlined"
          className="btnEnabill3"
          onClick={() => handleClick && handleClick(null)}
        >
          {t("Cancel")}
        </Button>
        <Button
          variant="contained"
          className="btnEnabill2"
          onClick={appState?.deliveryGiftCards?.is_gift ? handleUpdate : handleSubmit}
        >
          {appState?.deliveryGiftCards?.is_gift ? t("Update") : t("Add Gift")}
        </Button>
      </div>
      </div>
    </>
  );
}